import { StylesSxProps } from "../../theme/element";

//typography style
export const dashboardStyles: StylesSxProps = {
  titleText: {
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: 14,
    color: "#ffffff",
    pb: 1,
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
  },
};
